import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getMostRequiredISCO4JobInfo = async (HubIds: string[], ISICCodes: string[], ISCO2Codes: string[], ISCO4Codes: string[], Locations?: string[], fromQuarter?: string, toQuarter?: string, isEntryLevel?: boolean) => {
    const { path, method } = endpoints.occupationAndSector.getMostRequiredISCO4JobInfo;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, ISICCodes, ISCO2Codes, ISCO4Codes, Locations, fromQuarter, toQuarter, isEntryLevel },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
